import { createSelector } from 'reselect'
import { b64ToBlob,b64ToBlobRaw } from '../components/Common/imageCompressor'

const promocionesReducerDataSelector = state => state.promocionesReducer.getIn(["data"]).toJS()
export const promosSelector = createSelector(
  promocionesReducerDataSelector, (dataField) => {      
      return {
        promociones: dataField.promociones,
        imagen: null,
        imagenOriginal: null,
      }
    } 
  )
  export const promoEditSelector = createSelector(
    promocionesReducerDataSelector, (dataField) => {      
        return dataField.promoEdit
      } 
    )
  
    export const imageSelector = createSelector(
      promocionesReducerDataSelector, (dataField) => {
        /**cast image */
        return {/** se llama rubro para que sea compatible con la edicion de rubros y poder reutilizar */
             imagen: (dataField.imagen)&&b64ToBlob(dataField.imagen), 
             imagenOriginal: (dataField.imagenOriginal)&&b64ToBlob(dataField.imagenOriginal), 
             imagenOriginalRaw: (dataField.imagenOriginal)&&b64ToBlobRaw(dataField.imagenOriginal) 
        }
      } 
    )